const MASKS = {
  DATE: '99/99/9999',
  DATE_MM_YYYY: '99/9999',
  PHONE: '(99) 9999-9999',
  PHONE_DDI: '(99) 99999-9999',
  CPF: '999.999.999-99',
  RG: '99.999.999-99',
  CNPJ: '99.999.999/9999-99',
  DOCUMENT: '99.999.999/9999-99',
  CEP: '99999-999',
  CARD_NUMBER: '9999.9999.9999.9999',
  CVV: '999',
  HOUR: '99:99',
  TYPE_MASK: {
    DOCUMENT_CPF: '999.999.999-99',
    DOCUMENT_RG: '99.999.999-9',
    DOCUMENT_RG_2: '99.999.999',
    BIRTHDATE: '99/99/9999',
    PHONE: '(99) 99999-9999',
    CEPS: '99999-999',
  },
};

export default MASKS;
